import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import { format } from 'date-fns';
import { Audio } from 'react-loader-spinner';
import CreatableSelect from "react-select/creatable";
import { BsFillSendFill } from "react-icons/bs";
import { FaTrashAlt  } from 'react-icons/fa';
import { IoSearchSharp } from "react-icons/io5";
import { MdOutlineCancel } from 'react-icons/md';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer } from 'react-toastify';
import { Layout, Header } from '../../../../components';
import fetchData from '../../../../contexts/Api';

const CategoriesPrices = () => {

    const [reason, setReason] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [categories, setCategories] = useState([]);


 
   
    const [isLoading, setIsLoading] = useState(true);
    const [categoryList, setCategoryList] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState(new Set());
    const { isLoggedIn, userData, currentColor } = useContext(AppContext);
    const navigate = useNavigate(); // Get navigate function from React Router

    const filteredCategories = categories.filter(item =>
        item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = (categoryList || []).slice(indexOfFirstItem, indexOfLastItem);

    const paginate = pageNumber => setCurrentPage(pageNumber);

    useEffect(() => {
        setIsLoading(true);
        fetchCategories();
    }, []);

    const reasons = [
        { value: 'initial_stock', label: 'Initial Stock' },
        { value: 'quality_control', label: 'Quality Control' },
        { value: 'return_or_exchange', label: 'Return or Exchange' },
        { value: 'damaged_goods', label: 'Damaged Goods' },
        { value: 'expiry', label: 'Expiry' },
        { value: 'category_recall', label: 'Category Recall' },
        { value: 'obsolete_categories', label: 'Obsolete Categories' },
        { value: 'error_correction', label: 'Error Correction' },
        { value: 'competitive_pricing', label: 'Competitive Pricing' },
        { value: 'seasonal_discounts', label: 'Seasonal Discounts' },
        { value: 'economic_factors', label: 'Economic Factors' },
        { value: 'pricing_strategy_update', label: 'Pricing Strategy Update' },
    ];
    
    const fetchCategories = async () => {
        await fetchData('product_categories', userData, setCategories);
        setIsLoading(false);
    };

    const handleReasonChange = (newValue, actionMeta, item) => {
        item.adjust_reason = newValue ? newValue.value : '';
    };

    const handleAction = (action, po) => {
        // setActionType(action);
        // setPurchaseOrder(po);
        // setIsModalOpen(true);
    };

    
    

    const handleSearch = () => {
        const searchedCategories = filteredCategories.filter(category => !categoryList.some(p => p.id === category.id));
        setCategoryList(prevCategoryList => [...prevCategoryList, ...searchedCategories]);
        setSearchTerm(''); // Clear the search input after search
    };

    const handleRemoveCategory = (id) => {
        setCategoryList(prevList => prevList.filter(category => category.id !== id));
    };

    const handleCheckboxChange = (id) => {
        setSelectedCategories(prevSelectedCategories => {
            const newSelectedCategories = new Set(prevSelectedCategories);
            if (newSelectedCategories.has(id)) {
                newSelectedCategories.delete(id);
            } else {
                newSelectedCategories.add(id);
            }
            return newSelectedCategories;
        });
    };
        
    const handleClose = () => {
        navigate(-1); // Navigate back to the previous page
    };
        console.log(currentItems)
    return (
        <>
            <Layout>
                <div className="m-2 md:m-10 mt-24 p-2 md:p-2 bg-white rounded-3xl">
                    <ToastContainer position="top-center" autoClose={2000} />
                    <div className="flex ml-4 pt-4 text-center">
                        <Header category="" title="Adjust Prices" color={currentColor} />
                        {/* Close button */}
                    <div className="w-full sm:w-auto sm:flex-1  sm: px-4 py-2 flex flex-row justify-end">
                        <button
                            className="bg-transparent hover: hover:py-1 px-1 rounded mr-2 transition-all duration-300"
                            title="Close"
                            onClick={handleClose} // Call handleClose on click
                        >
                            < MdOutlineCancel size={24} color={currentColor}/>
                        </button>
                    </div>
                    </div>

                    <div>
                        {isLoading ? (
                            <div className="flex items-center flex-col">
                                <Audio height="80" width="80" radius="9" color={currentColor} ariaLabel="three-dots-loading" />
                                <p className="mt-2">Loading data. Please wait...</p>
                            </div>
                        ) : (
                            <>
                                <div className="w-full sm:w-auto sm:flex-1 sm:border-b-0 sm: px-4 py-2 flex flex-row justify-end ">
                                    <button 
                                        className="bg-${currentColor} mt-3 hover:bg-red-400 hover:text-white text-red-700 py-1 px-1 rounded mr-2 transition-all duration-300"
                                        title="Create Invoice"
                                    >
                                        <BsFillSendFill size={24} 
                                  
                                        /> 
                                    </button>
                                </div>

                                <div id="search" className="p-4 md:m-1 px-4 md:bg-gray-50 rounded-3xl">
                                    <div className="flex flex-wrap"> 
                                        <div className="w-full flex">
                                            <input
                                                type="text"
                                                placeholder="Search Category..."
                                                value={searchTerm}
                                                list="categoriesList"
                                                onChange={e => setSearchTerm(e.target.value)}
                                                className="flex-grow px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:border-indigo-500"
                                            />
                                            <button
                                                onClick={handleSearch}
                                                className="px-4 py-2 bg-blue-500 text-white rounded-r-md"
                                            >
                                                <IoSearchSharp/>
                                            </button>

                                            <datalist id="categoriesList">
                                                {categories.map((category, index) => (
                                                    <option key={index} value={category.name} />
                                                ))}
                                            </datalist>
                                        </div>            
                                    </div>
                                </div>
                                
                                <div className="mt-4 flex  max-w-lg">
                                        {Array.from({ length: Math.ceil((categoryList || []).length / itemsPerPage) }).map((_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => paginate(index + 1)}
                                                className={`mx-1 px-1 py-0.5 rounded-full text-xs text-white focus:outline-none ${currentPage === index + 1 ? 'bg-current' : ''}`}
                                                style={{ backgroundColor: currentColor, transition: 'background-color 0.3s ease-in-out' }}
                                            >
                                                {index + 1}
                                            </button>
                                        ))}
                                    </div>
                                    <div id="result" className="mx-2 p-2 mt-4 md:my-4 p-2 md:p-2 bg-gray-50 rounded-3xl">
    <div className="mx-auto bg-white rounded-lg shadow-lg">
        <div className="flex justify-between p-3 border-b">
            <div style={{ width: '2%', textAlign: 'left' }}> {/* Adjusted width */}
                <span className="text-sm text-slate-400">.</span>
            </div>
            <div style={{ width: '20%', textAlign: 'left' }}> {/* Adjusted width */}
                <span className="text-sm text-slate-400">Name</span>
            </div>
            
            <div style={{ width: '10%', textAlign: 'left' }}> {/* Adjusted width */}
                <span className="text-sm text-slate-400">Adjustment Rate</span>
            </div>
            <div style={{ width: '25%', textAlign: 'left' }}> {/* Adjusted width */}
                <span className="text-sm text-slate-400">Reason</span>
            </div>
        </div>

        {currentItems.map(item => (
            <div key={item.id} className="p-3 flex items-center justify-between border-t cursor-pointer hover:bg-gray-200">
                <div style={{ width: '2%', textAlign: 'left' }}> {/* Adjusted width */}
                    <button
                        onClick={() => handleRemoveCategory(item.id)}
                        className="text-red-500 hover:text-red-700"
                    >
                        <FaTrashAlt />
                    </button>
                </div>
                <div style={{ width: '20%' }}> {/* Adjusted width */}
                    <div className="leading-snug text-sm text-gray-900 font-bold">{item?.name}</div>
                    <div className="leading-snug text-xs text-slate-400">{item?.category_categories?.name}</div>
                </div>
                
                <div style={{ width: '10%' }}> {/* Adjusted width */}
                    <input
                        type="text"
                        name="rate"
                        className="text-sm text-gray-900 bg-transparent border border-gray-300 rounded-md px-2 py-1 w-full"
                        placeholder="Rate"
                        // value={item?.new_qty}
                    />
                </div>
                <div style={{ width: '25%' }}> {/* Adjusted width */}
                    <CreatableSelect
                        options={reasons}
                        name="adjust_reason"
                        onChange={(newValue, actionMeta) => handleReasonChange(newValue, actionMeta, item)}
                        placeholder="Select reason"
                        styles={{
                            container: (provided) => ({
                                ...provided,
                                width: '100%'
                            }),
                            placeholder: (provided) => ({
                                ...provided,
                                color: 'rgba(0, 0, 0, 0.5)',
                            }),
                        }}
                    />
                </div>
                
            </div>
        ))}
    </div>
    <div className="flex justify-end m-2">
                                        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded-lg"
                                        style={{ backgroundColor: currentColor }}
                                        //   onClick={handleSubmit}
                                        >
                                        Save
                                        </button>
                                    </div>
</div>


                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
};


export default CategoriesPrices;
